import { useGlobalModals } from "../components/shortcutContext";
import Modal from "../components/common/modal/Modal";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import AddIncome from "../pages/income/AddIncome";
import AddExpenses from "../components/expenses";
import AddCustomer from "./buddies/customer";
import AddSupplier from "./buddies/supplier";
import AddEmployee from "./buddies/Addemployees";
import NewBuy from "./newBuy";
import CashIn from "../pages/cashbook/cashIn";
import NewSale from "./newSale";
import AddCreditNotes from "../pages/credit Debit/AddCreditNotes";
import AddTasks from "./task";
import { getListsData } from "../store/actions/action";

const modalComponents = {
  incomeForm: AddIncome,
  expenseForm: AddExpenses,
  customerForm: AddCustomer,
  supplierForm: AddSupplier,
  employeeForm: AddEmployee,
  purchaseForm: NewBuy,
  cashbookForm: CashIn,
  saleForm: NewSale,
  taskForm: AddTasks,
  creditForm: AddCreditNotes,
};

const modalWidths = {

  employeeForm: "1200px", // Much wider for employee form (as requested)
  purchaseForm: "95%", // Full width for purchase
  saleForm: "95%", // Full width for sale
 
};

const ModalRenderer = () => {
  const { t } = useTranslation();
  const { modals, closeModal } = useGlobalModals();
  const dispatch = useDispatch();

  const renderModalContent = (modalName) => {
    const ModalComponent = modalComponents[modalName];
    if (!ModalComponent) return null;

    const commonProps = {
      close: () => closeModal(modalName),
      ...modals[modalName]?.props,
    };

    if (modalName === "incomeForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addExpense={commonProps.onSuccess}
          updateExpense={commonProps.onSuccess}
        />
      );
    }

    if (modalName === "expenseForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addExpense={commonProps.onSuccess}
          updateExpense={commonProps.onSuccess}
        />
      );
    }
    if (modalName === "customerForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addCustomer={commonProps.onSuccess}
          updateCustomer={commonProps.onSuccess}
        />
      );
    }
    if (modalName === "supplierForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addSupplier={commonProps.onSuccess}
          updateSupplier={commonProps.onSuccess}
        />
      );
    }
    if (modalName === "employeeForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addEmployeeItem={commonProps.onSuccess}
          updateEmployeeItem={commonProps.onSuccess}
        />
      );
    }
    if (modalName === "purchaseForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addBuy={commonProps.onSuccess}
          updateBuy={commonProps.onSuccess}
        />
      );
    }
    if (modalName === "cashbookForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addCashbook={commonProps.onSuccess}
          updateCashbook={commonProps.onSuccess}
        />
      );
    }
    if (modalName === "saleForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          addSale={commonProps.onSuccess}
          updateSale={commonProps.onSuccess}
        />
      );
    }
    // In ModalRenderer.js, update taskForm section:
    if (modalName === "taskForm") {
      return (
        <ModalComponent
          {...commonProps}
          businessUuid={commonProps.businessUuid}
          item={commonProps.item}
          onSubmit={commonProps.onSubmit} // From TasksList
          onSuccess={commonProps.onSuccess} // From shortcut
          status={commonProps.status || "todo"}
        />
      );
    }
    return <ModalComponent {...commonProps} />;
  };

  const getModalTitle = (modalName, props) => {
    const titles = {
      incomeForm: props?.item
        ? t("LANGUAGE.UPDATE_INCOME")
        : t("LANGUAGE.NEW_INCOME"),
      expenseForm: props?.item
        ? t("LANGUAGE.UPDATE_EXPENSE")
        : t("LANGUAGE.NEW_EXPENSE"),
      customerForm: props?.item
        ? t("LANGUAGE.UPDATE_CUSTOMER")
        : t("LANGUAGE.NEW_CUSTOMER"),
      supplierForm: props?.item
        ? t("LANGUAGE.UPDATE_SUPPLIER")
        : t("LANGUAGE.ADD_SUPPLIER"),
      employeeForm: props?.item
        ? t("LANGUAGE.UPDATE_EMPLOYEE")
        : t("LANGUAGE.ADD_EMPLOYEE"),
      purchaseForm: props?.item
        ? t("LANGUAGE.UPDATE_PURCHASE")
        : t("LANGUAGE.PURCHASE_ORDER"),
      cashbookForm: props?.item
        ? t("LANGUAGE.UPDATE_TRANSACTION")
        : t("LANGUAGE.NEW_TRANSACTION"),
      saleForm: props?.item
        ? t("LANGUAGE.UPDATE_SALE")
        : t("LANGUAGE.NEW_SALE"),
      taskForm: props?.item
        ? `${t("FORM.UPDATE")} ${t("FORM.TASK")}`
        : `${t("FORM.ADD")} ${t("FORM.TASK")}`,
    };
    return titles[modalName] || `${modalName} Form`;
  };

  // Function to get modal width based on modal name
  const getModalWidth = (modalName) => {
    // You can also add responsive widths based on screen size
    const isMobile = window.innerWidth < 768;
    
    // Special handling for employee form - make it extra wide
    if (modalName === "employeeForm") {
      return isMobile ? "95%" : "1200px";
    }
    
    // Return configured width or default
    return modalWidths[modalName] || modalWidths.default;
  };

  return (
    <>
      {Object.entries(modals).map(
        ([modalName, modalState]) =>
          modalState.isOpen && (
            <Modal
              key={modalName}
              isOpen={true}
              closeModal={() => closeModal(modalName)}
              modalHeader={getModalTitle(modalName, modalState.props)}
              width={getModalWidth(modalName)}
            >
              {renderModalContent(modalName)}
            </Modal>
          )
      )}
    </>
  );
};

export default ModalRenderer;